// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1EiNu","label":"Radio_label__nbrwN","checkMark":"Radio_checkMark__k1yIc","disabled":"Radio_disabled__148dk"};